/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { getCurrentConstructionSite } from '@construction-sites/store/construction-sites.selectors';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { ConstructionSite, Tour, TourAppointmentClass } from '@shared/models';
import { getTourAppointmentClasses } from '@tours/store/tours.selectors';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-form-basic-information',
    templateUrl: './form-basic-information.component.html',
    styleUrls: ['./form-basic-information.component.scss'],
    standalone: false
})
export class FormBasicInformationComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;
  @Input() tour: Tour;
  tourAppointmentClasses$: Observable<TourAppointmentClass[]>;
  constructionSite$: Observable<ConstructionSite>;

  constructor(private store: Store<State>) { }

  ngOnInit(): void {
    this.tourAppointmentClasses$ = this.store.select(getTourAppointmentClasses);
    this.constructionSite$ = this.store.select(getCurrentConstructionSite);
  }
}
